import React from 'react'
import { Loader2 } from 'lucide-react'

export default function Loading() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-20 h-20 rounded-2xl bg-white flex items-center justify-center mx-auto mb-4 shadow-lg animate-pulse p-2">
          <img src="/ncinq-favicon.png" alt="Logo" className="w-full h-full object-contain" />
        </div>
        <div className="flex items-center justify-center gap-2 text-gray-600">
          <Loader2 size={20} className="animate-spin" />
          <span>Loading nCinq Invoice...</span>
        </div>
      </div>
    </div>
  )
}
